import { PageableQuery } from '@peca/backoffice/models/pageable-query.model';

export interface ProductGroupDefaultSpecDto {
  overwrite: boolean;
  value: string;
  description: string;
  category: string;
  important: string;
}

export interface ProductGroupDefaultDto {
  id: string;
  productGroupId: string;
  productGroupName: string;
  updatedAt?: string | null;
  updatedBy?: string | null;
  specifications: Record<string, ProductGroupDefaultSpecDto>;
}

export interface CreateProductGroupDefaultDto {
  productGroupId: string;
  productGroupName: string;
  specifications: Record<string, ProductGroupDefaultSpecDto>;
}

export interface UpdateProductGroupDefaultDto {
  productGroupId: string;
  productGroupName: string;
  specifications: Record<string, ProductGroupDefaultSpecDto>;
}

export interface ProductGroupDefaultQuery extends PageableQuery {
  productGroupId?: string;
}

export interface SpecDefinition {
  id: string;
  description: string;
  category: string;
  important: string;
  unit: string;
}

export const PRODUCT_GROUP_DEFAULT_SPECS: Record<string, SpecDefinition> = {
  '91a8a7c0-d49a-4d36-9a5d-0a4081322211': {
    id: '91a8a7c0-d49a-4d36-9a5d-0a4081322211',
    description: 'Peso bruto',
    category: 'Logístico',
    important: 'false',
    unit: 'kg',
  },
  'f35311f0-d5dd-44d5-bcf1-26eeed691249': {
    id: 'f35311f0-d5dd-44d5-bcf1-26eeed691249',
    description: 'Comprimento da embalagem',
    category: 'Logístico',
    important: 'false',
    unit: 'mm',
  },
  '66e304ea-e5c7-468e-9256-cee87d61cb83': {
    id: '66e304ea-e5c7-468e-9256-cee87d61cb83',
    description: 'Altura da embalagem',
    category: 'Logístico',
    important: 'false',
    unit: 'mm',
  },
  'c9e0494b-46a5-4e85-b940-cf8161e4ede5': {
    id: 'c9e0494b-46a5-4e85-b940-cf8161e4ede5',
    description: 'Largura da embalagem',
    category: 'Logístico',
    important: 'false',
    unit: 'mm',
  },
};

export const AVAILABLE_SPECS_LIST: SpecDefinition[] = Object.values(PRODUCT_GROUP_DEFAULT_SPECS);

/**
 * Formata um valor numérico para o padrão brasileiro com 3 casas decimais (ex: 1,5 -> "1,500").
 */
export function formatToPtBrNumber(val: string | number | null | undefined): string {
  if (val === null || val === undefined || val === '') return '';
  if (typeof val === 'number') {
    return val.toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 });
  }

  let str = String(val).replace(/(kg|mm)/gi, '').trim();
  if (!str) return '';

  if (str.includes(',')) {
    str = str.replace(/\./g, '').replace(',', '.');
  } else {
    const dotCount = (str.match(/\./g) || []).length;
    if (dotCount > 1) {
      str = str.replace(/\./g, '');
    }
  }

  const num = parseFloat(str);
  if (isNaN(num)) return '';
  return num.toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 });
}

/**
 * Extrai a parte numérica de uma string que pode conter a unidade (ex: "1,500 kg" -> "1,500").
 */
export function extractNumericPart(val: string | null | undefined): string {
  if (!val) return '';
  return val.replace(/(kg|mm)/gi, '').trim();
}
